export function getAccessToken() {
    const cookieValue = getAuthTokenCookieValue();
    if (!cookieValue) {
        return '';
    }
    const authToken = JSON.parse(cookieValue);
    const accessToken = authToken?.['session']?.['accessToken'] || '';
    return accessToken;
}

function getAuthTokenCookieValue() {
    const cookiePieces = decodeURIComponent(document.cookie)?.split(';') || [];
    const cookie = cookiePieces
        .find((piece) => piece.trim().startsWith('AUTH_TOKEN'))
        ?.trim();
    return cookie?.split('=')?.[1];
}
